<div class="text-center mt-4" *ngIf="isLoading">
  <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
  <strong>{{ statusMessage }}</strong>
</div>

<div *ngIf="!isLoading && isFailed">
  {{ errorMessage }}
</div>

<div *ngIf="!isLoading && !isFailed">
  <div *ngIf="!payoutProviderAccount">
    <p>{{ 'PAYOUT_EXPLANATION' | translate }}.</p>

    <p *ngIf="canAddPayoutMethod">
      <strong>{{ 'PAYOUT_METHOD_EXPLANATION' | translate }}</strong> <br />
      {{ 'PAYOUT_RELEASE_SCHEDULE_EXPLANATION' | translate }}.
    </p>
    <p *ngIf="canAddPayoutMethod">{{ 'PAYOUT_FUNDS_DELAY_EXPLANATION' | translate }}.</p>
  </div>
  <div *ngIf="payoutProviderAccount">
    <ul class="list-group">
      <!-- TODO: Iterate over list of payout provider accounts -->
      <div id="selectPayoutAccount" class="list-group-item">
        <div class="d-flex mt-2">
          <div class="flex-shrink-0">
            <img class="payout-provider-logo" [src]="payoutProvider.logo" />
          </div>

          <div class="flex-grow-1 ms-3 d-flex flex-column justify-content-center gap-1">
            <div class="small" *ngIf="getPayoutMethodType(payoutProviderAccount)">
              {{ getPayoutMethodType(payoutProviderAccount) }}
            </div>
            <h4 class="media-heading mb-0">
              {{ getPayoutMethodHeadline(payoutProviderAccount) }}
            </h4>
            <div class="media-body">
              {{ getPayoutMethodDetails(payoutProviderAccount) }}
              <a class="href" (click)="managePayoutProviderAccount(); $event.stopPropagation()">
                <span *ngIf="isBankAccountSetupCompleted">{{ 'CHANGE' | translate }}</span>
                <span *ngIf="!isBankAccountSetupCompleted">{{ 'NEW_BANK_ACCOUNT' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
        <hr />

        <div>
          <div class="form-group" *ngIf="payoutProviderAccountName">
            <div class="small">Associated Business</div>
            <h6 class="media-heading">{{ payoutProviderAccountName }}</h6>
          </div>

          <div class="small">
            <div class="form-group">{{ 'BUSINESS_VERIFICATION_EXPLANATION' | translate }}</div>
            <div>
              <span class="verification-status-label">Verification status:</span>
              <span *ngIf="isPayoutVerificationMissingInformation" class="verification-status-text text-warning">
                {{ 'VERIFICATION_STATUS_MISSING_INFO' | translate }}
              </span>
              <span *ngIf="isPayoutVerificationAwaitingManualReview" class="verification-status-text text-info">
                {{ 'VERIFICATION_STATUS_PENDING' | translate }}
              </span>
              <span *ngIf="isPayoutVerificationSuccessful" class="verification-status-text text-success">
                {{ 'VERIFICATION_STATUS_COMPLETE' | translate }}
              </span>
            </div>
          </div>

          <div class="mt-2 text-end">
            <a
              id="updatePayoutAccount"
              class="btn btn-sm btn-info btn-config"
              (click)="managePayoutProviderAccount()"
              *ngIf="!isPayoutVerificationMissingInformation"
            >
              {{ managePayoutAccountCta | translate }}
            </a>
            <a
              id="verifyPayoutAccount"
              class="btn btn-sm btn-warning btn-config"
              (click)="managePayoutProviderAccount()"
              *ngIf="isPayoutVerificationMissingInformation"
            >
              {{ verifyPayoutAccountCta | translate }}
            </a>
          </div>
        </div>
      </div>
    </ul>
  </div>

  <div class="form-group" *ngIf="!enableStandardStripeAccounts && !payoutProviderAccount">
    <!-- Add payout provider account button -->
    <button
      id="addPayoutProviderAccount"
      class="btn btn-add"
      [class.btn-primary]="!isPayoutMethodsAvailable"
      [class.btn-info]="isPayoutMethodsAvailable"
      (click)="addPayoutProviderAccount()"
      [disabled]="!canAddPayoutMethod"
    >
      {{ 'ADD_PAYOUT_METHOD' | translate }}
      <lh-shared-ui-tooltip
        [body]="'ADD_PAYOUT_METHOD_AFTER_ADDING_SHOP' | translate"
        *ngIf="!canAddPayoutMethod"
      ></lh-shared-ui-tooltip>
    </button>
  </div>

  <div class="form-group" *ngIf="enableStandardStripeAccounts">
    <!-- Stripe connect button -->
    <button id="connectWithStripe" class="btn btn-primary" (click)="connectWithStripe(true)">
      {{ 'CONNECT_WITH_STRIPE' | translate }}
    </button>
  </div>
</div>

<!--Stripe Connect confirmation modal-->
<div
  class="modal fade"
  bsModal
  #confirmStripeConnectModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-sm full-height-footer">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div>{{ 'CONNECT_WITH_STRIPE' | translate }}</div>
        </h4>
        <button
          id="closeConfirmStripeConnectModal"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="confirmStripeConnectModal.hide()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <span>{{ 'EXISTING_STRIPE_ACCOUNT' | translate }}</span>
      </div>

      <div class="modal-footer">
        <button
          id="confirmConnectWithStripe"
          class="btn btn-warning"
          [disabled]="isLoading"
          (click)="connectWithStripe(false)"
        >
          {{ 'OK' | translate }}
        </button>
        <button id="cancelConnectWithStripe" class="btn btn-info" (click)="confirmStripeConnectModal.hide()">
          {{ 'CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!--Create payout provider account modal-->
<div
  class="modal fade"
  bsModal
  #newPayoutAccountModal="bs-modal"
  #newPayoutAccountModalRef
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-sm full-height-footer">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div>{{ 'ADD_PAYOUT_METHOD' | translate }}</div>
          <span style="font-size: medium">{{ 'DETAILS_FOR_PAYOUT_ACCOUNT' | translate }}</span>
        </h4>
        <button
          id="closeCreatePayoutAccountModal"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="closeCreatePayoutProviderAccountModal()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="text-center" *ngIf="isLoading">
          <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
          <strong>{{ statusMessage }}</strong>
        </div>

        <div class="list-group" *ngIf="!isLoading">
          <div class="form-group">
            <label>{{ 'SELECT_BUSINESS_COUNTRY' | translate }}.</label>
            <select
              id="countryPicker"
              class="form-select ng-pristine ng-valid ng-touched"
              name="countryPicker"
              [(ngModel)]="selectedCountry"
            >
              <option *ngFor="let option of supportedCountries" [value]="option.countryCode">
                {{ option.name | translate }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="businessType">{{ 'SELECT_BUSINESS_TYPE' | translate }}.</label>
            <select
              id="businessType"
              type="text"
              name="businessType"
              class="form-select ng-pristine ng-valid ng-touched"
              [(ngModel)]="businessType"
            >
              <option value="company">{{ 'Company' | translate }}</option>
              <option value="individual">{{ 'Individual' | translate }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="businessLegalName">{{ 'BUSINESS_LEGAL_NAME' | translate }}. </label>
            <input
              id="businessLegalName"
              name="businessLegalName"
              class="form-control ng-pristine missing ng-invalid invalid ng-touched"
              [(ngModel)]="businessLegalName"
            />
          </div>
        </div>

        <div class="modal-footer text-left">
          <button
            id="confirmCreatePayoutProviderAccount"
            class="btn btn-lg btn-primary me-0"
            [disabled]="isLoading || !canGoForward"
            (click)="createPayoutAccount()"
          >
            {{ 'Create Account' | translate }} <i class="icon-forward"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
